<template>
    <kt-datatable v-if="user" v-bind="datatableProps"></kt-datatable>
</template>

<script>
import columns from './../../payman/datatable/columns'
import actionsColumn from './../../payman/components/actions-column'
import { ApiUrl } from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('user', ['user']),
        datatableProps() {
            return {
                withPanel: false,
                id: "payman_gateway_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('payman'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                user_id: this.user.id
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: true,
                sortable: false,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
}
</script>

<style>

</style>